import { captureException } from '@sentry/react'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { regionQuery } from '@/state/regions/region'
import { dashboardRegionTeamQuery } from '@/state/teams/teams'

export const Route = createFileRoute('/dashboard/$regionId')({
  beforeLoad: async ({ context, params }) => {
    const { data: region } = await context.queryClient.fetchQuery(regionQuery(params.regionId))
    if (!region) {
      throw notFound()
    }
    const { data: teams } = await context.queryClient.fetchQuery(dashboardRegionTeamQuery(region))
    return { region, teams }
  },
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
